<div fxLayout="row wrap"   class="product-list container">
  <div *ngFor="let item of products" class="product-card" fxFlex="48"  fxFlex.xs="100">
    <div class="card-content" fxLayout="row" fxLayoutAlign="start center">
      <img [src]="item.image" alt="product image" class="product-img">
      <div class="product-info">
        <h3 class="product-title">{{ item.title }}</h3>
        <div class="product-price">
          <span class="sale-price">₹{{ item.salePrice }}</span>
          <span class="original-price">₹{{ item.originalPrice }}</span>
        </div>
        <div class="product-meta">
          {{ item.weight }} &nbsp;|&nbsp;
          {{ item.pieces }} &nbsp;|&nbsp;
          {{ item.serving }}
        </div>
      </div>
    </div>
  </div>
</div>

